import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Typography from '@material-ui/core/Typography'

import Header from '../../components/Header'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'

import _ from 'lodash'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  container: {
    margin: '16px',
    overflowY: 'auto',
    height: '100%',
  },
  agreeContent: {
    ...fontDefault,
    color: '#999999',
    fontSize: '14px',
  },
  agreeContentHead: {
    ...fontDefault,
    color: '#333333',
    fontSize: '14px',
    fontWeight: 'bold',
  },
}

class Agreement extends Component {
  state = {
    modalVisible: false,
  }

  readPolicy = () => {
    this.setState({
      modalVisible: true,
    })
  }

  goToNextPage = () => {
    const {
      history: { push },
      setUserInput,
    } = this.props
    setUserInput({
      isAgree: true,
    })
    push('/summary')
    //setTimeout(() => {
    //  window.scrollTo(0, document.body.scrollHeight);
    //}, 50);
  }

  backButton = () => {
    const {
      history: { push },
    } = this.props
    push('/summary')
    //setTimeout(() => {
    //  window.scrollTo(0, document.body.scrollHeight);
    //}, 50);
  }

  render() {
    const { classes, currentProduct } = this.props
    return (
      <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Header>
          <TopBar arrowLeft={this.backButton}>
            <Typography align="center" className={classes.textTopBar}>
              ข้อกำหนดและเงื่อนไข
            </Typography>
          </TopBar>
        </Header>

        <div
          style={{
            backgroundColor: '#eff0f4',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            marginTop: '50px',
          }}
        >
          {currentProduct === 'V' ? (
            <div className={classes.container}>
              <p className={classes.agreeContentHead}>
                ข้อกำหนดและเงื่อนไขประกันภัยรถยนต์ภาคสมัครใจ
              </p>
              <p className={classes.agreeContent}>
                • ผู้ขอเอาประกันภัยสามารถซื้อประกันภัยรถยนต์ภาคสมัครใจได้เพียง 1
                ฉบับต่อรถยนต์ 1 คัน
              </p>
              <p className={classes.agreeContent}>
                •
                ผู้ขอเอาประกันภัยสามารถซื้อประกันภัยรถยนต์ภาคสมัครใจในนามบุคคลธรรมดาเท่านั้น
              </p>
              <p className={classes.agreeContent}>
                • รับประกันภัยรถยนต์นั่งและรถกระบะส่วนบุคคล
                ไม่ใช้รับจ้างหรือให้เช่า
              </p>
              <p className={classes.agreeContent}>
                • รับประกันภัยอายุรถยนต์ 2-15 ปี
              </p>
              <p className={classes.agreeContent}>
                •
                คุ้มครองอุปกรณ์ตกแต่งที่ติดตั้งมากับตัวรถโดยโรงงานประกอบรถยนต์เท่านั้น
                ไม่รวมถึงอุปกรณ์ตกแต่งเพิ่มเติม
              </p>
              <p className={classes.agreeContent}>
                • ทรู มันนี่ เป็นเพียงช่องทางชำระเงินทางอิเล็กทรอนิกส์เท่านั้น
                การเสนอขายประกันภัยโดยบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
              </p>
              <p className={classes.agreeContent}>
                • การพิจารณารับประกันภัยจะเป็นไปตามเงื่อนไขและหลักเกณฑ์ของบริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน)
              </p>
              <p className={classes.agreeContent}>
                •
                ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                ก่อนตัดสินใจทำประกันภัย
              </p>

              <p className={classes.agreeContentHead}>
                ข้อกำหนดและเงื่อนไขประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
              </p>
              <p className={classes.agreeContent}>
                • ผู้ขอเอาประกันภัย พ.ร.บ สำหรับรถยนต์นั่งส่วนบุคคลไม่เกิน 7
                ที่นั่ง และรถยนต์บรรทุกส่วนบุคคล ไม่เกิน 3 ตัน เท่านั้น
              </p>
              <p className={classes.agreeContent}>
                • ผู้ขอเอาประกันภัยสามารถซื้อ พ.ร.บ ได้เพียง 1 ฉบับต่อรถยนต์ 1
                คัน
              </p>
              <p className={classes.agreeContent}>
                •
                ผู้ขอเอาประกันภัยสามารถซื้อประกันภัยรถยนต์ภาคสมัครใจในนามบุคคลธรรมดาเท่านั้น
              </p>
              <p className={classes.agreeContent}>
                • ทรู มันนี่ เป็นเพียงช่องทางชำระเงินทางอิเล็กทรอนิกส์เท่านั้น
                การเสนอขายประกันภัยทำโดยบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
              </p>
              <p className={classes.agreeContent}>
                • การพิจารณารับประกันภัยจะเป็นไปตามเงื่อนไข
                และหลักเกณฑ์ของบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
              </p>
              <p className={classes.agreeContent}>
                •
                ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                ก่อนตัดสินใจทำประกันภัย
              </p>

              <p className={classes.agreeContentHead}>
                รายการส่งเสริมการขายและข้อกำหนดเงื่อนไข
              </p>
              <p className={classes.agreeContent}>
                • รับเงินคืน 15% ของค่าเบี้ยประกันภัย
                เมื่อซื้อประกันภัยรถยนต์ภาคสมัครใจของกรุงเทพประกันภัยทางออนไลน์ที่เชื่อมผ่านแอพพลิเคชั่น
                TrueMoney Wallet และชำระค่าเบี้ยประกันภัยด้วย TrueMoney Wallet
                ตั้งแต่ 1 ตุลาคม 2562 – 31 ธันวาคม 2562
              </p>
              <p className={classes.agreeContent}>
                • รายการส่งเสริมการขายนี้จัดขึ้นโดย บริษัท ทรู มันนี่ จํากัด
                (“บริษัท”)
              </p>
              <p className={classes.agreeContent}>
                • เงินคืน 15%
                จะคำนวณจากค่าเบี้ยประกันภัยรถยนต์ภาคสมัครใจอัตราสุทธิ
                ที่ไม่รวมภาษีมูลค่าเพิ่มและอากรแสตมป์
              </p>
              <p className={classes.agreeContent}>
                • บริษัทจะให้เงินคืน (Cash back) เข้าบัญชี TrueMoney Wallet
                ของผู้ชำระเงินเท่านั้น โดยโอนเข้าไปภายใน 3
                วันทำการนับถัดจากวันที่การชำระเงินค่าเบี้ยประกันภัยดังกล่าวสำเร็จ
                และบริษัทได้รับการยืนยันในการรับทำประกันภัยจากบริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน)
              </p>
              <p className={classes.agreeContent}>
                • เงินคืนไม่สามารถแลกเปลี่ยนเป็นเงินสด หรือรางวัลอื่นได้
                รวมทั้งไม่สามารถโอนสิทธิในการได้รับเงินคืนให้กับผู้อื่น
              </p>
              <p className={classes.agreeContent}>
                • กรณีที่การซื้อผลิตภัณฑ์ประกันภัยไม่สำเร็จ
                หรือมีการยกเลิกการซื้อผลิตภัณฑ์ประกันภัย หรือบริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน) ปฏิเสธรับประกันภัย
                หรือมีการบอกเลิกสัญญา
                หรือมีการคืนเงินเบี้ยประกันภัยดังกล่าวไม่ว่าด้วยเหตุใดก็ตาม
                บริษัทขอสงวนสิทธิในการเรียกคืนเงินคืนจากผู้ที่มีสิทธิได้รับเงินคืนและ/หรือหักจากบัญชี
                TrueMoney Wallet ทันทีโดยไม่จำเป็นต้องแจ้งให้ทราบ
              </p>
              <p className={classes.agreeContent}>
                • ผู้เข้าร่วมรายการส่งเสริมการขายรับทราบว่า ผลิตภัณฑ์ประกันภัย
                การเสนอขายประกันภัย เงื่อนไขการรับประกันภัย
                รวมถึงการพิจารณารับประกันภัย ทำโดยบริษัท กรุงเทพประกันภัย จำกัด
                (มหาชน) แต่เพียงฝ่ายเดียว
                บริษัทเป็นเพียงผู้บริการช่องทางชำระเงินอิเล็กทรอนิกส์เท่านั้น
              </p>
              <p className={classes.agreeContent}>
                • บริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงระยะเวลารายการส่งเสริมการขาย
                วิธีการร่วมรายการส่งเสริมการขาย จำนวนเงินคืน
                รายละเอียดเงื่อนไขและรายละเอียดอื่นใด
                การยกเลิกรายการส่งเสริมการขายตามความเหมาะสม
                โดยไม่ต้องแจ้งให้ทราบ ในกรณีที่มีข้อโต้แย้งใดๆ เกิดขึ้น
                คำตัดสินของบริษัทถือเป็นที่สิ้นสุด
              </p>
              <p className={classes.agreeContent}>
                • การให้เงินคืนเป็นดุลยพินิจของบริษัทเท่านั้น
                บริษัทสงวนสิทธิ์ในการตรวจสอบข้อมูล ยกเลิกการให้เงินคืน
                และ/หรือดำเนินการอื่นใด หากบริษัทตรวจสอบพบว่ามีการฉ้อฉล ทุจริต
                หรือดำเนินการใดๆ อันมิชอบด้วยกฎหมาย
                เพื่อให้ได้รับเงินคืนหรือเพื่อวัตถุประสงค์อื่นใด
              </p>
              <p className={classes.agreeContent}>
                •
                ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                ก่อนตัดสินใจทำประกันภัย
                สอบถามรายละเอียดผลิตภัณฑ์ประกันภัยเพิ่มเติมได้ที่บริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน) โทร. 02-285-8888
              </p>
              <p className={classes.agreeContent}>
                • สอบถามรายละเอียดรายการส่งเสริมการขายเพิ่มเติมได้ที่ TrueMoney
                Call Center โทร.1240
              </p>

              <p className={classes.agreeContentHead}>
                รายการส่งเสริมการขายและข้อกำหนดเงื่อนไข
              </p>
              <p className={classes.agreeContent}>
                • รับเงินคืนสูงสุดถึง 300 บาท เมื่อซื้อประกันภัยรถยนต์ภาคบังคับ
                (พ.ร.บ.) กับกรุงเทพประกันภัยทางออนไลน์ที่เชื่อมผ่านแอพพลิเคชั่น
                TrueMoney Wallet และชำระค่าเบี้ยประกันภัยด้วย TrueMoney Wallet
                ตั้งแต่ 1 ตุลาคม 2562 – 31 ธันวาคม 2562
              </p>
              <p className={classes.agreeContent}>
                • รายการส่งเสริมการขายนี้จัดขึ้นโดย บริษัท ทรู มันนี่ จํากัด
                (“บริษัท”)
              </p>
              <p className={classes.agreeContent}>
                • บริษัทจะให้เงินคืนโดยโอนเข้าบัญชี TrueMoney Wallet
                ตามรายละเอียดอัตราดังต่อไปนี้
              </p>
              <p className={classes.agreeContent}>
                • เงินคืนจำนวน 300 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                ประเภทรถตู้นั่งส่วนบุคคลไม่เกิน 12 ที่นั่ง (ค่าเบี้ยประกันภัย
                1,182.35 บาท) หรือ
              </p>
              <p className={classes.agreeContent}>
                • เงินคืนจำนวน 250 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                ประเภทรถกระบะบรรทุกส่วนบุคคลไม่เกิน 4 ตัน (ค่าเบี้ยประกันภัย
                967.28 บาท) หรือ
              </p>
              <p className={classes.agreeContent}>
                • เงินคืนจำนวน 150 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                ประเภทรถยนต์ส่วนบุคคลไม่เกิน 7 ที่นั่ง (ค่าเบี้ยประกันภัย 645.21
                บาท)
              </p>
              <p className={classes.agreeContent}>
                • จำกัดสิทธิ์ในการได้รับเงินคืนไม่เกิน 10 ครั้งต่อ 1
                หมายเลขบัตรประชาชนต่อเดือน
              </p>
              <p className={classes.agreeContent}>
                • บริษัทจะให้เงินคืน (Cash back) เข้าบัญชี TrueMoney Wallet
                ของผู้ชำระเงินเท่านั้น โดยโอนเข้าไปภายใน 3
                วันทำการนับถัดจากวันที่การชำระเงินค่าเบี้ยประกันภัยดังกล่าวสำเร็จ
                และบริษัทได้รับการยืนยันในการรับทำประกันภัยจากบริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน)
              </p>
              <p className={classes.agreeContent}>
                • เงินคืนไม่สามารถแลกเปลี่ยนเป็นเงินสด หรือรางวัลอื่นได้
                รวมทั้งไม่สามารถโอนสิทธิในการได้รับเงินคืนให้กับผู้อื่น
              </p>
              <p className={classes.agreeContent}>
                • กรณีที่การซื้อผลิตภัณฑ์ประกันภัยไม่สำเร็จ
                หรือมีการยกเลิกการซื้อผลิตภัณฑ์ประกันภัย หรือบริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน) ปฏิเสธรับประกันภัย
                หรือมีการบอกเลิกสัญญา
                หรือมีการคืนเงินเบี้ยประกันภัยดังกล่าวไม่ว่าด้วยเหตุใดก็ตาม
                บริษัทขอสงวนสิทธิในการเรียกคืนเงินคืนจากผู้ที่มีสิทธิได้รับเงินคืนและ/หรือหักจากบัญชี
                TrueMoney Wallet ทันทีโดยไม่จำเป็นต้องแจ้งให้ทราบ
              </p>
              <p className={classes.agreeContent}>
                • ผู้เข้าร่วมรายการส่งเสริมการขายรับทราบว่า ผลิตภัณฑ์ประกันภัย
                การเสนอขายประกันภัย เงื่อนไขการรับประกันภัย
                รวมถึงการพิจารณารับประกันภัย ทำโดยบริษัท กรุงเทพประกันภัย จำกัด
                (มหาชน) แต่เพียงฝ่ายเดียว
                บริษัทเป็นเพียงผู้บริการช่องทางชำระเงินอิเล็กทรอนิกส์เท่านั้น
              </p>
              <p className={classes.agreeContent}>
                • บริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงระยะเวลารายการส่งเสริมการขาย
                วิธีการร่วมรายการส่งเสริมการขาย จำนวนเงินคืน
                รายละเอียดเงื่อนไขและรายละเอียดอื่นใด
                การยกเลิกรายการส่งเสริมการขายตามความเหมาะสม
                โดยไม่ต้องแจ้งให้ทราบ ในกรณีที่มีข้อโต้แย้งใดๆ เกิดขึ้น
                คำตัดสินของบริษัทถือเป็นที่สิ้นสุด
              </p>
              <p className={classes.agreeContent}>
                • การให้เงินคืนเป็นดุลยพินิจของบริษัทเท่านั้น
                บริษัทสงวนสิทธิ์ในการตรวจสอบข้อมูล ยกเลิกการให้เงินคืน
                และ/หรือดำเนินการอื่นใด หากบริษัทตรวจสอบพบว่ามีการฉ้อฉล ทุจริต
                หรือดำเนินการใดๆ อันมิชอบด้วยกฎหมาย
                เพื่อให้ได้รับเงินคืนหรือเพื่อวัตถุประสงค์อื่นใด
              </p>
              <p className={classes.agreeContent}>
                •
                ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                ก่อนตัดสินใจทำประกันภัย
                สอบถามรายละเอียดผลิตภัณฑ์ประกันภัยเพิ่มเติมได้ที่บริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน) โทร. 02-285-8888
              </p>
              <p className={classes.agreeContent}>
                • สอบถามรายละเอียดรายการส่งเสริมการขายเพิ่มเติมได้ที่ TrueMoney
                Call Center โทร.1240
              </p>
            </div>
          ) : (
            <div className={classes.container}>
              <p className={classes.agreeContentHead}>
                ข้อกำหนดและเงื่อนไขประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
              </p>
              <p className={classes.agreeContent}>
                • ผู้ขอเอาประกันภัย พ.ร.บ สำหรับรถยนต์นั่งส่วนบุคคลไม่เกิน 7
                ที่นั่ง และรถยนต์บรรทุกส่วนบุคคล ไม่เกิน 3 ตัน เท่านั้น
              </p>
              <p className={classes.agreeContent}>
                • ผู้ขอเอาประกันภัยสามารถซื้อ พ.ร.บ ได้เพียง 1 ฉบับต่อรถยนต์ 1
                คัน
              </p>
              <p className={classes.agreeContent}>
                •
                ผู้ขอเอาประกันภัยสามารถซื้อประกันภัยรถยนต์ภาคสมัครใจในนามบุคคลธรรมดาเท่านั้น
              </p>
              <p className={classes.agreeContent}>
                • ทรู มันนี่ เป็นเพียงช่องทางชำระเงินทางอิเล็กทรอนิกส์เท่านั้น
                การเสนอขายประกันภัยทำโดยบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
              </p>
              <p className={classes.agreeContent}>
                • การพิจารณารับประกันภัยจะเป็นไปตามเงื่อนไข
                และหลักเกณฑ์ของบริษัท กรุงเทพประกันภัย จำกัด (มหาชน)
              </p>
              <p className={classes.agreeContent}>
                •
                ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                ก่อนตัดสินใจทำประกันภัย
              </p>

              <p className={classes.agreeContentHead}>
                รายการส่งเสริมการขายและข้อกำหนดเงื่อนไข
              </p>
              <p className={classes.agreeContent}>
                • รับเงินคืนสูงสุดถึง 300 บาท เมื่อซื้อประกันภัยรถยนต์ภาคบังคับ
                (พ.ร.บ.) กับกรุงเทพประกันภัยทางออนไลน์ที่เชื่อมผ่านแอพพลิเคชั่น
                TrueMoney Wallet และชำระค่าเบี้ยประกันภัยด้วย TrueMoney Wallet
                ตั้งแต่ 1 ตุลาคม 2562 – 31 ธันวาคม 2562
              </p>
              <p className={classes.agreeContent}>
                • รายการส่งเสริมการขายนี้จัดขึ้นโดย บริษัท ทรู มันนี่ จํากัด
                (“บริษัท”)
              </p>
              <p className={classes.agreeContent}>
                • บริษัทจะให้เงินคืนโดยโอนเข้าบัญชี TrueMoney Wallet
                ตามรายละเอียดอัตราดังต่อไปนี้
              </p>
              <p className={classes.agreeContent}>
                • เงินคืนจำนวน 300 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                ประเภทรถตู้นั่งส่วนบุคคลไม่เกิน 12 ที่นั่ง (ค่าเบี้ยประกันภัย
                1,182.35 บาท) หรือ
              </p>
              <p className={classes.agreeContent}>
                • เงินคืนจำนวน 250 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                ประเภทรถกระบะบรรทุกส่วนบุคคลไม่เกิน 4 ตัน (ค่าเบี้ยประกันภัย
                967.28 บาท) หรือ
              </p>
              <p className={classes.agreeContent}>
                • เงินคืนจำนวน 150 บาท สำหรับประกันภัยรถยนต์ภาคบังคับ (พ.ร.บ.)
                ประเภทรถยนต์ส่วนบุคคลไม่เกิน 7 ที่นั่ง (ค่าเบี้ยประกันภัย 645.21
                บาท)
              </p>
              <p className={classes.agreeContent}>
                • จำกัดสิทธิ์ในการได้รับเงินคืนไม่เกิน 10 ครั้งต่อ 1
                หมายเลขบัตรประชาชนต่อเดือน
              </p>
              <p className={classes.agreeContent}>
                • บริษัทจะให้เงินคืน (Cash back) เข้าบัญชี TrueMoney Wallet
                ของผู้ชำระเงินเท่านั้น โดยโอนเข้าไปภายใน 3
                วันทำการนับถัดจากวันที่การชำระเงินค่าเบี้ยประกันภัยดังกล่าวสำเร็จ
                และบริษัทได้รับการยืนยันในการรับทำประกันภัยจากบริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน)
              </p>
              <p className={classes.agreeContent}>
                • เงินคืนไม่สามารถแลกเปลี่ยนเป็นเงินสด หรือรางวัลอื่นได้
                รวมทั้งไม่สามารถโอนสิทธิในการได้รับเงินคืนให้กับผู้อื่น
              </p>
              <p className={classes.agreeContent}>
                • กรณีที่การซื้อผลิตภัณฑ์ประกันภัยไม่สำเร็จ
                หรือมีการยกเลิกการซื้อผลิตภัณฑ์ประกันภัย หรือบริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน) ปฏิเสธรับประกันภัย
                หรือมีการบอกเลิกสัญญา
                หรือมีการคืนเงินเบี้ยประกันภัยดังกล่าวไม่ว่าด้วยเหตุใดก็ตาม
                บริษัทขอสงวนสิทธิในการเรียกคืนเงินคืนจากผู้ที่มีสิทธิได้รับเงินคืนและ/หรือหักจากบัญชี
                TrueMoney Wallet ทันทีโดยไม่จำเป็นต้องแจ้งให้ทราบ
              </p>
              <p className={classes.agreeContent}>
                • ผู้เข้าร่วมรายการส่งเสริมการขายรับทราบว่า ผลิตภัณฑ์ประกันภัย
                การเสนอขายประกันภัย เงื่อนไขการรับประกันภัย
                รวมถึงการพิจารณารับประกันภัย ทำโดยบริษัท กรุงเทพประกันภัย จำกัด
                (มหาชน) แต่เพียงฝ่ายเดียว
                บริษัทเป็นเพียงผู้บริการช่องทางชำระเงินอิเล็กทรอนิกส์เท่านั้น
              </p>
              <p className={classes.agreeContent}>
                • บริษัทสงวนสิทธิ์ในการเปลี่ยนแปลงระยะเวลารายการส่งเสริมการขาย
                วิธีการร่วมรายการส่งเสริมการขาย จำนวนเงินคืน
                รายละเอียดเงื่อนไขและรายละเอียดอื่นใด
                การยกเลิกรายการส่งเสริมการขายตามความเหมาะสม
                โดยไม่ต้องแจ้งให้ทราบ ในกรณีที่มีข้อโต้แย้งใดๆ เกิดขึ้น
                คำตัดสินของบริษัทถือเป็นที่สิ้นสุด
              </p>
              <p className={classes.agreeContent}>
                • การให้เงินคืนเป็นดุลยพินิจของบริษัทเท่านั้น
                บริษัทสงวนสิทธิ์ในการตรวจสอบข้อมูล ยกเลิกการให้เงินคืน
                และ/หรือดำเนินการอื่นใด หากบริษัทตรวจสอบพบว่ามีการฉ้อฉล ทุจริต
                หรือดำเนินการใดๆ อันมิชอบด้วยกฎหมาย
                เพื่อให้ได้รับเงินคืนหรือเพื่อวัตถุประสงค์อื่นใด
              </p>
              <p className={classes.agreeContent}>
                •
                ผู้ขอเอาประกันภัยควรศึกษารายละเอียดของความคุ้มครองและเงื่อนไขกรมธรรม์ประกันภัย
                ก่อนตัดสินใจทำประกันภัย
                สอบถามรายละเอียดผลิตภัณฑ์ประกันภัยเพิ่มเติมได้ที่บริษัท
                กรุงเทพประกันภัย จำกัด (มหาชน) โทร. 02-285-8888
              </p>
              <p className={classes.agreeContent}>
                • สอบถามรายละเอียดรายการส่งเสริมการขายเพิ่มเติมได้ที่ TrueMoney
                Call Center โทร.1240
              </p>
            </div>
          )}
          <SubmitButton onClick={this.goToNextPage}>
            ยอมรับเงื่อนไข
          </SubmitButton>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setUserInput: data => {
      dispatch({
        type: 'USER_INPUT',
        data,
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Agreement))
